import { connect } from "react-redux";

import * as queries from "./queries";
import * as commands from "./commands";

function mapStateToProps(state) {
  return { notes: state.notes };
}

function mapDispatchToProps(dispatch) {
  return {
    getNotesById: (borrowerId, isInvestor) => {
      dispatch(queries.get_notes_by_id(borrowerId, isInvestor));
    },

    createNote: (borrowerId, text, type, isInvestor) => {
      dispatch(commands.create_note(borrowerId, text, type, isInvestor));
    },
  };
}

const notesConnect = connect(mapStateToProps, mapDispatchToProps);
export default notesConnect;
